// Strip NUL/control chars that browsers drop on render (breaks highlight offsets)
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export const cleanAnswer = (text) => (text ? text.replace(CONTROL_CHARS, '') : text);

export const cleanSubmissionAnswers = (submission) => submission && {
  ...submission,
  task1_answer: cleanAnswer(submission.task1_answer),
  task2_answer: cleanAnswer(submission.task2_answer),
};
